<h1 matDialogTitle>Delivery Fee KM's</h1>

<mat-dialog-content>
  <div>
    <!-- Line Details -->
    <div>
      <form [formGroup]="form">
        <form class="dynamic-form" [formGroup]="form" style="width: 100%">
          <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">
            <mat-form-field fxFlex="100" width="100%">
              <mat-label>KM For Delivery Calculation</mat-label>
              <input matInput style="text-align: right;" type="number" formControlName="km">
            </mat-form-field>
          </div>
        </form>
      </form>
    </div>

    <!-- Warehouse Details -->
    <div>

    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button (click)="save()">Save</button>
</mat-dialog-actions>
